"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decorator = void 0;
const symbol = Symbol("Matcher");
class Decorator {
    static registerMatcher(prototype, method, checker) {
        let matcher = prototype[symbol] ?? new Map();
        let checkers = matcher.get(method) ?? [];
        checkers.unshift(checker);
        matcher.set(method, checkers);
        prototype[symbol] = matcher;
    }
    static koa(handler, config = {
        debug: false
    }) {
        let matcher = handler.constructor.prototype[symbol] ?? new Map;
        return async (ctx, next) => {
            loop: for (let [method, checkers] of matcher.entries()) {
                for (let checker of checkers) {
                    if (await checker(ctx)) {
                        if (config.debug) {
                            console.debug('koa', handler.constructor, method, 'check', checker, 'pass', ctx.status);
                        }
                    }
                    else {
                        if (config.debug) {
                            console.debug('koa', handler.constructor, method, 'check', checker, 'failed', ctx.status);
                        }
                        continue loop;
                    }
                }
                if (config.debug) {
                    console.debug('koa', handler.constructor, method, 'all checks successed');
                }
                await handler[method](ctx, next);
                if (config.debug) {
                    console.debug('koa', handler.constructor, method, 'executed', ctx.status);
                }
            }
            await next();
        };
    }
}
exports.Decorator = Decorator;
//# sourceMappingURL=Decorator.js.map